













































import { Component, Vue, Prop } from "vue-property-decorator";
import ClickOutside from "@/directives/ClickOutside";

export type SlottedSelectGroup = {
  id: string;
  name: string;
  items: SlottedSelectItem[];
};

export type SlottedSelectItem = {
  icon: string | null;
  id: string;
  text: string;
  additional: string | null;
  croppedLogo?: string;
};

@Component({ directives: { ClickOutside } })
export default class VSlottedSelect extends Vue {
  @Prop({ default: "Label" }) readonly label!: string;
  @Prop({ required: true }) readonly selected!: SlottedSelectItem;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly items!: SlottedSelectItem[];
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly groups!: SlottedSelectGroup[];
  @Prop({ default: 400 }) readonly dropDownSize!: number;

  private selectedItem = Object.assign({}, this.selected);
  isOpen = false;

  get hasGroups() {
    return this.groups.length > 0;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  select(item: SlottedSelectItem, group?: SlottedSelectGroup) {
    this.selectedItem = item;
    this.$emit("selected", item, group);
    this.isOpen = false;
  }
}
